@if (ghostState) {
  <div class="item">
    <x-ghost-product-media class="media" [style.width]="mediaSize + 'px'"></x-ghost-product-media>

    <div class="body-content flex-grow-1 d-flex flex-column">
      <x-ghost-title class="mb-2" size="large"></x-ghost-title>
      <x-ghost-paragraph [rows]="4" class="description"></x-ghost-paragraph>
      <x-ghost-title class="mt-auto" size="large"></x-ghost-title>
    </div>
  </div>
} @else {
  <ng-container *ngIf="addToCartControl$ | async as operation" [xOperation]="operation">
    <ng-container *ngIf="productItem$ | async as productItem">
      <div class="item" [class.adding-to-cart]="operation.status === 'loading'">
        <div class="media" [style.width]="mediaSize + 'px'">
          <a [id]="productItem.slug" [routerLink]="productItem.detailUrl">
            <x-product-badges [badges]="productItem.badges"></x-product-badges>
            <div class="main-media" *ngIf="productItem.mainMedia as mainMedia">
              <x-product-media
                [media]="mainMedia"
                [width]="mediaSize"
                [height]="mediaSize"
                [blurHash]="productItem.blurHash"
              ></x-product-media>
            </div>
          </a>
        </div>

        <div class="body-content flex-grow-1">
          <header class="mat-headline-4 text-truncate" [innerText]="productItem.title"></header>

          <div class="description mat-display-2 text-truncate">
            <span>{{ productItem.description }}</span>
          </div>

          <div class="footer mt-auto mb-auto">
            <div class="price mat-body-1">
              {{ productItem.variation === 'OPTION' ? 'From ' : '' }}
              {{
                productItem.variantAvailability.price.amount
                  | money: productItem.variantAvailability.price.currency
              }}
            </div>
            <div class="availability">
              <x-variant-availability
                [productAvailability]="productItem.variantAvailability"
              ></x-variant-availability>
            </div>
          </div>

          <div class="actions mt-1">
            <x-product-add-to-bag
              [productView]="productItem"
              [loading]="operation.status === 'loading'"
              (quantityChanged)="addToCart(productItem, $event)"
            ></x-product-add-to-bag>
            <x-wishlist-action [productId]="productItem.id"></x-wishlist-action>
          </div>
        </div>
      </div>
    </ng-container>

    <x-shop-error-operation *xOperationError="let error" [error]="error"></x-shop-error-operation>
  </ng-container>
}
